import {
  Pagination,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

interface CustomPaginationProps {
  pageIndex: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  setPageIndex: (pageIndex: number) => void;
}

const CustomPagination = ({
  pageIndex,
  canPreviousPage,
  canNextPage,
  setPageIndex,
}: CustomPaginationProps) => {
  return (
    <div className="flex py-4">
      <Pagination>
        <PaginationItem>
          <PaginationPrevious
            onClick={() => setPageIndex(pageIndex - 1)}
            disabled={!canPreviousPage}
            variant="ghost"
          />
        </PaginationItem>
        <PaginationItem>
          <PaginationNext
            onClick={() => setPageIndex(pageIndex + 1)}
            disabled={!canNextPage}
            variant="ghost"
          />
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default CustomPagination;
